export * from './detail/general-messages-detail.page'
export * from './list/general-messages-list.page'
